/* eslint-disable react/prefer-es6-class */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import createReactClass from 'create-react-class';
import { Form } from 'antd';

const FormInstanceCreate = ({ children, ...rest }) => {
  const [form] = Form.useForm();
  return React.cloneElement(children, { form, ...rest });
};

const WrapperForm = ({ children, form, ...rest }) => {
  if (form) {
    return React.cloneElement(children, { form, ...rest });
  }

  return <FormInstanceCreate {...rest}>{children}</FormInstanceCreate>;
};

class FormInstance {
  static create(WrappedComponent) {
    return createReactClass({
      render() {
        const { children, ...rest } = this.props;
        return (
          <WrapperForm {...rest}>
            <WrappedComponent>{children}</WrappedComponent>
          </WrapperForm>
        );
      }
    });
  }
}

export default FormInstance;
